import testingConstants from 'utils/testingConstants';

const SKELETON_KEYS = Array.from({ length: 8 }, (_, index) => `api-key-skeleton-${index}`);

const ApiKeysLoadingSkeleton = () => (
  <div className="divide-gray-20 flex flex-col divide-y" data-testid={testingConstants.apiKeysLoadingSkeleton}>
    {SKELETON_KEYS.map((key) => (
      <div key={key} className="flex items-center justify-between gap-2 py-3">
        <div className="flex flex-col gap-2">
          <div className="bg-gray-30 h-4 w-32 animate-pulse rounded" />
          <div className="flex gap-2">
            <div className="bg-gray-30 h-3 w-40 animate-pulse rounded" />
            <div className="bg-gray-30 h-3 w-16 animate-pulse rounded-full" />
          </div>
        </div>
        <div className="bg-gray-30 h-9 w-9 animate-pulse rounded-xl" />
      </div>
    ))}
  </div>
);

export default ApiKeysLoadingSkeleton;
